import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import Replace2x from "util/Extensions/ReplaceExtension";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const EInvoiceInfoUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [activeBankId, setActiveBankId] = useState();
  const [eArchiveUserName, setEArchiveUserName] = useState();
  const [eArchivePassword, setEArchivePassword] = useState();
  const [erpCode, setErpCode] = useState();
  const [tenantTitle, setTenantTitle] = useState();
  const [vkn, setVkn] = useState();
  const [taxOffice, setTaxOffice] = useState();
  const [address, setAddress] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [code, setCode] = useState();
  const [xsltName, setXsltName] = useState();
  const [eArchiveXsltName, setEArchiveXsltName] = useState();
  const [eInvoiceProgramId, setEInvoiceProgramId] = useState();

  useEffect(() => {
    if (props.data) {
      props.data.notifyMails = props.data.notifyMails?.split(",");
      form.setFieldsValue(props.data);
      setActiveBankId(props.data.bankId);
      setEArchiveUserName(props.data.eArchiveUserName);
      setEArchivePassword(props.data.eArchivePassword);
      setErpCode(props.data.erpCode);
      setXsltName(props.data.xsltName);
      setEArchiveXsltName(props.data.eArchiveXsltName);
      setEInvoiceProgramId(props.data.eInvoiceProgramId);
      const tenantId = Replace2x(localStorage.getItem("tenantId"));
      RequestHandler.get(`/Tenant/getbyid/${tenantId}`).then((response) => {
        setTenantTitle(response.fullName);
        setVkn(response.vkn);
        setTaxOffice(response.taxOffice);
        setAddress(response.address);
        setCity(response.city);
        setState(response.state);
      });
      RequestHandler.get(`/EInvoiceCode?$filter=isDefault eq true`, false).then(
        (res) => {
          setCode(res.value[0]?.code);
        }
      );
    }
  }, [props.data]);

  const onChangeAddress = (e) => {
    setAddress(e.target.value);
  };
  const onChangeCity = (e) => {
    setCity(e.target.value);
  };
  const onChangeState = (e) => {
    setState(e.target.value);
  };
  const onChangeTenantTitle = (e) => {
    setTenantTitle(e.target.value);
  };
  const onChangeTaxOffice = (e) => {
    setTaxOffice(e.target.value);
  };
  const onChangeVkn = (e) => {
    setVkn(e.target.value);
  };
  const onChangeEInvoiceCode = (e) => {
    setCode(e.target.value);
  };
  const onChangeXsltName = (e) => {
    setXsltName(e.target.value);
  };
  const onChangeEArchiveXsltName = (e) => {
    setEArchiveXsltName(e.target.value);
  };

  const onFinish = (values) => {
    values.notifyMails = values.notifyMails?.join(",");
    debugger;
    RequestHandler.put(`/EinvoiceInfo`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();

        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="eInvoiceInfoUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      fields={[
        {
          name: "tenantTitle",
          value:
            tenantTitle?.toString() === "" ? null : tenantTitle?.toString(),
        },
        { name: "vkn", value: vkn?.toString() === "" ? null : vkn?.toString() },
        {
          name: "taxOffice",
          value: taxOffice?.toString() === "" ? null : taxOffice?.toString(),
        },
        {
          name: "address",
          value: address?.toString() === "" ? null : address?.toString(),
        },
        {
          name: "city",
          value: city?.toString() === "" ? null : city?.toString(),
        },
        {
          name: "state",
          value: state?.toString() === "" ? null : state?.toString(),
        },
        {
          name: "eInvoiceCode",
          value: code?.toString() === "" ? null : code?.toString(),
        },
        {
          name: "xsltName",
          value: xsltName?.toString() === "" ? null : xsltName?.toString(),
        },
        {
          name: "eArchiveXsltName",
          value:
            eArchiveXsltName?.toString() === ""
              ? null
              : eArchiveXsltName?.toString(),
        },
        { name: "eInvoiceProgramId", value: eInvoiceProgramId },
      ]}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="eInvoiceProgramId" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label={"Kullanıcı Adı"}
            name="userName"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={"Şifre"}
            name="password"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input />
          </Form.Item>

          {eArchiveUserName !== null ? (
            <Form.Item
              label={"EArşiv Kullanıcı Adı"}
              name="eArchiveUserName"
              rules={[{ required: true, whitespace: true }]}
            >
              <Input />
            </Form.Item>
          ) : null}

          {eArchivePassword !== null ? (
            <Form.Item
              label={"EArşiv Kullanıcı Şifre"}
              name="eArchivePassword"
              rules={[{ required: true, whitespace: true }]}
            >
              <Input />
            </Form.Item>
          ) : null}

          {erpCode !== null ? (
            <Form.Item
              label={"Erp Kodu"}
              name="erpCode"
              rules={[{ required: true, whitespace: true }]}
            >
              <Input />
            </Form.Item>
          ) : null}

          <Form.Item
            label={"Vergi Dairesi"}
            name="taxOffice"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input onChange={onChangeTaxOffice} />
          </Form.Item>

          <Form.Item
            label={"Vkn"}
            name="vkn"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input
              type="number"
              onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
              onChange={onChangeVkn}
            />
          </Form.Item>

          <Form.Item
            label={"Adres"}
            name="address"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input onChange={onChangeAddress} />
          </Form.Item>

          <Form.Item
            label={"İl"}
            name="city"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input onChange={onChangeCity} />
          </Form.Item>

          <Form.Item
            label={"İlçe"}
            name="state"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input onChange={onChangeState} />
          </Form.Item>

          <Form.Item
            label={"Şirket Ünvanı"}
            name="tenantTitle"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input onChange={onChangeTenantTitle} />
          </Form.Item>

          <Form.Item
            label={"Fatura Kodu"}
            name="eInvoiceCode"
            rules={[{ required: true, whitespace: true }]}
          >
            <Input maxLength={3} onChange={onChangeEInvoiceCode} />
          </Form.Item>
          {xsltName !== null ? (
            <Form.Item
              label={"Varsayılan Şablon Adı"}
              name="xsltName"
              rules={[{ required: true, whitespace: true }]}
            >
              <Input maxLength={100} onChange={onChangeXsltName} />
            </Form.Item>
          ) : null}
          {eArchiveXsltName !== null ? (
            <Form.Item
              label={"Varsayılan E-Arşiv Şablon Adı"}
              name="eArchiveXsltName"
              rules={[{ required: true, whitespace: true }]}
            >
              <Input maxLength={100} onChange={onChangeEArchiveXsltName} />
            </Form.Item>
          ) : null}

          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default EInvoiceInfoUpdateForm;
